var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"radialBar","height":"400","options":_vm.apexChatData.radialBarChart.chartOptions,"series":_vm.apexChatData.radialBarChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }